import {useLocale} from './useLocale';

const messages = {
  ru: {
    title: 'Что-то пошло не так',
    description: 'Попробуйте обновить страницу или зайти позже',
  },
  en: {
    title: 'Something went wrong',
    description: 'Try refreshing the page or come back later',
  },
  zh: {
    title: '出了些问题',
    description: '尝试刷新页面或稍后再回来',
  },
};

export const useFormErrorMessages = () => {
  const locale = useLocale();

  return messages[locale];
};
